import React from "react";
import "./style.css";
import { useI18n } from "../i18n/I18nProvider";
import { SectionTitle } from "../i18n/SectionTitle";

function About_me() {
  const { t } = useI18n();
  return (
    <div>
      {/* blog section start */}
      <div
        className="mail_section_1 layout_padding"
        style={{ paddingTop: "170px" }}
      >
        {/* fisrt section */}
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <SectionTitle
                beforeKey="about.title"
                afterKey="about.titleAccent"
                className="blog_taital"
              />

              <p className="blog_text">{t("about.intro")}</p>
            </div>
          </div>
        </div>
        {/* second section skills */}
        <div className="container">
          <div className="services_section_2 skills ">
            <div className="row">
              <div className="col-sm-12">
                <SectionTitle
                  beforeKey="about.skillsTitle"
                  afterKey="about.skillsAccent"
                  className="services_taital"
                />
              </div>
              <div
                className="container"
                data-aos="fade-up"
                data-aos-delay={100}
              >
                <div className="row skills-content skills-animation">
                  <div className="col-lg-6">
                    <div className="progress">
                      <span className="skill">
                        <span>HTML</span> <i className="val">100%</i>
                      </span>
                      <div className="progress-bar-wrap">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={100}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </div>
                    {/* End Skills Item */}
                    <div className="progress">
                      <span className="skill">
                        <span>CSS</span> <i className="val">90%</i>
                      </span>
                      <div className="progress-bar-wrap">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={90}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "90%" }}
                        />
                      </div>
                    </div>
                    {/* End Skills Item */}
                    <div className="progress">
                      <span className="skill">
                        <span>JavaScript</span> <i className="val">75%</i>
                      </span>
                      <div className="progress-bar-wrap">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={75}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "75%" }}
                        />
                      </div>
                    </div>
                    {/* End Skills Item */}
                    <div className="progress">
                      <span className="skill">
                        <span>ANGULAR</span> <i className="val">75%</i>
                      </span>
                      <div className="progress-bar-wrap">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={90}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "75%" }}
                        />
                      </div>
                    </div>

                    {/* End Skills Item */}

                    <div className="progress">
                      <span className="skill">
                        <span>express</span> <i className="val">75%</i>
                      </span>
                      <div className="progress-bar-wrap">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={55}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "75%" }}
                        />
                      </div>
                    </div>
                    {/* End Skills Item */}
                  </div>
                  <div className="col-lg-6">
                    <div className="progress">
                      <span className="skill">
                        <span>PHP native</span> <i className="val">80%</i>
                      </span>
                      <div className="progress-bar-wrap">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={80}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "80%" }}
                        />
                      </div>
                    </div>
                    {/* End Skills Item */}
                    <div className="progress">
                      <span className="skill">
                        <span>WordPress/CMS</span> <i className="val">90%</i>
                      </span>
                      <div className="progress-bar-wrap">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={90}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "90%" }}
                        />
                      </div>
                    </div>
                    {/* End Skills Item */}

                    <div className="progress">
                      <span className="skill">
                        <span>React</span> <i className="val">75%</i>
                      </span>
                      <div className="progress-bar-wrap">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={90}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "75%" }}
                        />
                      </div>
                    </div>
                    {/* End Skills Item */}
                    <div className="progress">
                      <span className="skill">
                        <span>Node</span> <i className="val">75%</i>
                      </span>
                      <div className="progress-bar-wrap">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={55}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "75%" }}
                        />
                      </div>
                    </div>
                    {/* End Skills Item */}
                    <div className="progress">
                      <span className="skill">
                        <span>Photoshop</span> <i className="val">50%</i>
                      </span>
                      <div className="progress-bar-wrap">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={55}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "50%" }}
                        />
                      </div>
                    </div>
                    {/* End Skills Item */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* third section education */}
        <div className="container resume">
          <div className="row">
            {/* Left Column */}
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
              <h3 className="resume-title">{t("about.resume.summaryTitle")}</h3>
              <div className="resume-item pb-0">
                <h4>{t("about.resume.name")}</h4>
                <p>
                  <em>
                    {t("about.resume.summaryText")}
                  </em>
                </p>
                <ul>
                  <li>{t("about.resume.location")}</li>
                  <li>
                    <a href="mailto:abdenacer1993@gmail.com">
                      abdenacer1993@gmail.com
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://github.com/abdenacer1993"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      GitHub
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/abdenacer-hasnaoui-91bb86211/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </li>
                </ul>
              </div>

              <h3 className="resume-title">{t("about.resume.educationTitle")}</h3>
              <div className="resume-item">
                <h4>{t("about.resume.education.degreeTitle")}</h4>
                <h5>{t("about.resume.education.degreeYear")}</h5>
                <p>
                  <em>{t("about.resume.education.degreeSchool")}</em>
                </p>
              </div>
              <h3 className="resume-title">{t("about.resume.trainingTitle")}</h3>
              <div className="resume-item">
                <h4>{t("about.resume.training.mernTitle")}</h4>
                <h5>{t("about.resume.training.mernYear")}</h5>
                <p>
                  <em>{t("about.resume.training.mernSchool")}</em>
                </p>
                <ul>
                  <li>{t("about.resume.training.mernPoints.0")}</li>
                  <li>{t("about.resume.training.mernPoints.1")}</li>
                  <li style={{marginBottom: '11px;'}}>
                    {t("about.resume.training.mernPoints.2")}
                  </li>
                  
                </ul>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay={200}>
              <h3 className="resume-title">{t("about.resume.experienceTitle")}</h3>
              <div className="resume-item">
                <h4>{t("about.experience.proConcept.title")}</h4>
                <h5>{t("about.experience.proConcept.period")}</h5>
                <p style={{ width: "100%" }}>
                  <em>{t("about.experience.proConcept.summary")}</em>
                </p>
                <ul>
                  <li>{t("about.experience.proConcept.points.0")}</li>
                  <li>{t("about.experience.proConcept.points.1")}</li>
                  <li>{t("about.experience.proConcept.points.2")}</li>
                  <li>{t("about.experience.proConcept.points.3")}</li>
                  <li>{t("about.experience.proConcept.points.4")}</li>
                </ul>
              </div>
              <div className="resume-item">
                <h4>{t("about.experience.xworld.title")}</h4>
                <h5>{t("about.experience.xworld.period")}</h5>
                <p style={{ width: "100%" }}>
                  <em>{t("about.experience.xworld.summary")}</em>
                </p>
                <ul>
                  <li>{t("about.experience.xworld.points.0")}</li>
                  <li>{t("about.experience.xworld.points.1")}</li>
                  <li>{t("about.experience.xworld.points.2")}</li>
                  <li>{t("about.experience.xworld.points.3")}</li>
                  <li>{t("about.experience.xworld.points.4")}</li>
                </ul>
              </div>
              <div className="resume-item">
                <h4>{t("about.experience.freelance.title")}</h4>

                <h5>{t("about.experience.freelance.period")}</h5>
                <p style={{ width: "100%" }}>
                  <em>
                    {t("about.experience.freelance.summary")}
                  </em>
                </p>
                <ul>
                  <li>
                    <strong>{t("about.experience.freelance.frontLabel")}</strong>
                    {t("about.experience.freelance.frontValue")}
                  </li>
                  <li>
                    <strong>{t("about.experience.freelance.backLabel")}</strong>
                    {t("about.experience.freelance.backValue")}
                  </li>
                  <li>
                    <strong>{t("about.experience.freelance.cmsLabel")}</strong>
                    {t("about.experience.freelance.cmsValue")}
                  </li>
                </ul>
              </div>
              <div className="resume-item">
                <h4>{t("about.experience.sandlist.title")}</h4>
                <p style={{ width: "100%" }}>
                  <em>
                    {t("about.experience.sandlist.summary")}
                  </em>
                </p>
                <h5>{t("about.experience.sandlist.period")}</h5>
                <p>
                  <em>{t("about.experience.sandlist.location")}</em>
                </p>
                <ul>
                  <li>{t("about.experience.sandlist.points.0")}</li>
                  <li>{t("about.experience.sandlist.points.1")}</li>
                </ul>
                <p style={{ marginTop: "10px" }}>
                  <em>
                    <strong>{t("about.experience.sandlist.toolsLabel")}</strong>
                    {t("about.experience.sandlist.toolsValue")}
                  </em>
                </p>
              </div>
              <div className="resume-item">
                <h4>{t("about.experience.integrator.title")}</h4>
                <h5>{t("about.experience.integrator.period")}</h5>
                <p>
                  <em>{t("about.experience.integrator.location")}</em>
                </p>
                <ul>
                  <li>{t("about.experience.integrator.points.0")}</li>
                  <li>{t("about.experience.integrator.points.1")}</li>
                  <li>{t("about.experience.integrator.points.2")}</li>
                </ul>
                <p style={{ marginTop: "10px" }}>
                  <em>
                    <strong>{t("about.experience.integrator.toolsLabel")}</strong>
                    {t("about.experience.integrator.toolsValue")}
                  </em>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* last section */}
        <div className="container">
          <div className="row">
            <div
              className="col-sm-12 services_section_2 skills "
              style={{ marginBottom: "50px;" }}
            >
              <SectionTitle
                beforeKey="about.cvTitle"
                afterKey="about.cvAccent"
                className="blog_taital"
              />
              <div className="cvbtn">
                <div className="send_bt">
                  <a
                    href="./Cv/abdenacer hasnaoui an_cv.pdf"
                    download
                    className="pro-btn pro-btn--primary"
                  >
                    {t("about.cvEn")}
                  </a>
                </div>
                <div className="send_bt">
                  <a
                    href="./Cv/Hasnaoui Abdenacer fr_cv.pdf"
                    download
                    className="pro-btn pro-btn--primary"
                  >
                    {t("about.cvFr")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About_me;
